import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4120aaf1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "item"
};
const _hoisted_4 = {
  key: 0,
  class: "num"
};
const _hoisted_5 = {
  key: 1,
  class: "bottom"
};
const _hoisted_6 = {
  class: "item"
};
const _hoisted_7 = {
  key: 0,
  class: "num"
};
const _hoisted_8 = {
  key: 1,
  class: "bottom"
};
const _hoisted_9 = {
  class: "item"
};
const _hoisted_10 = {
  key: 0,
  class: "num"
};
const _hoisted_11 = {
  key: 1,
  class: "bottom"
};
const _hoisted_12 = {
  class: "item"
};
const _hoisted_13 = {
  key: 0,
  class: "num"
};
const _hoisted_14 = {
  key: 1,
  class: "bottom"
};
const _hoisted_15 = {
  class: "user"
};
const _hoisted_16 = {
  class: "user_info"
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  class: "container"
};
const _hoisted_19 = {
  class: "left"
};
const _hoisted_20 = {
  class: "left"
};
const _hoisted_21 = {
  class: "user_img"
};
const _hoisted_22 = {
  key: 0,
  class: "user_name"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "店铺名称:", -1));
const _hoisted_24 = {
  key: 1,
  class: "user_phone"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "店铺手机号:", -1));
const _hoisted_26 = {
  class: "right"
};
const _hoisted_27 = {
  key: 0
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "冻结现金积分:", -1));
const _hoisted_29 = {
  key: 1
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "销售总额:", -1));
const _hoisted_31 = {
  key: 2
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "让利总额:", -1));
const _hoisted_33 = {
  key: 3
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "押金:", -1));
const _hoisted_35 = {
  class: "user_bin"
};
const _hoisted_36 = {
  class: "bottoms"
};
const _hoisted_37 = {
  class: "entry"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "headers"
}, "快捷入口", -1));
const _hoisted_39 = {
  class: "btn_box"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "padding": "0 10px",
    "padding-bottom": "20px",
    "color": "red"
  }
}, " 注:商家名称和商家头像需后台审核通过后显示 ", -1));
const _hoisted_41 = {
  class: "dialog-footer"
};
const _hoisted_42 = {
  class: "dialog-footer"
};
const _hoisted_43 = {
  class: "dialog-footer"
};
const _hoisted_44 = {
  class: "dialog-footer"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__tip"
}, " 内容须包含三证合一证件照、法人身份证正面照、法人身份证反面照、开户银行许可证照。 压缩 zip包后上传,最大限制为 9 M 注:文件名不能为中文 ", -1));
const _hoisted_46 = {
  class: "dialog-footer"
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "个人信息", -1));
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "yinghangka"
}, "个人绑定银行信息", -1));
import * as echarts from 'echarts';
import { ajax } from '@/api/ajax.js';
import { ref, onMounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { menuStore } from '@/store/Menu';
import { ElMessage, ElMessageBox } from 'element-plus';
export default {
  __name: 'index',
  setup(__props) {
    // 引入echart
    const upload = ref();
    const editRuleFormRef = ref(null);
    const withdrawCashRuleFormRef = ref(null);
    const redeemRuleFormRef = ref(null);
    const bindPeopleRuleFormRef = ref(null);
    const bindCompRuleFormRef = ref(null);
    const echart = ref(null);
    const state = menuStore();
    const data = reactive({
      fileList: [],
      cities: [],
      binList: [],
      // 饼图数据
      userInfo: '',
      yhbm: [],
      // 银行编码
      yhdm: [],
      // 查看个人绑定的信息
      lookPeopleInfo: {},
      editform: {
        name: '',
        phone: '',
        weixin: '',
        imgData: '',
        // 提交服务器的图片数据
        imgUrl: '',
        // 图片的url地址
        ne: ''
      },
      // 编辑表单数据
      withdrawCashform: {
        name: '',
        // 银行名称
        kname: '',
        // 开户行名称
        id: '',
        // 卡号
        username: '',
        // 真实姓名
        num: '' // 金额数量
      },

      //提现表单数据
      redeemform: {
        num: ''
      },
      //赎回表单数据
      bindPeopleform: {
        card_name: '',
        card_id: '',
        cert_id: '',
        phone: ''
      },
      // 绑定个人银行账号表单数据
      bindCompform: {
        name: '',
        prov_code: '',
        area_code: '',
        social_credit_code: '',
        social_credit_code_expires: '',
        business_scope: '',
        legal_person: '',
        legal_cert_id: '',
        legal_cert_id_expires: '',
        legal_mp: '',
        address: '',
        bank_code: '',
        bank_acct_type: '',
        card_no: '',
        card_name: '',
        attach_file: ''
      } // 绑定企业银行账号表单数据
    });

    const homeInfo = ref({});
    const router = useRouter();
    const radio = ref('');
    const editVisible = ref(false);
    const redeemVisible = ref(false);
    const withdrawCashVisible = ref(false);
    const bingPeopleVisible = ref(false);
    const bindCompVisible = ref(false);
    const changePeopleInfoVisible = ref(false);
    const getData = async () => {
      ajax('Merchant/datalist', data1 => {
        homeInfo.value = data1.data;
        data.binList = data1.data.hot;
        data.userInfo = data1;
        data.editform.imgUrl = data1.shop.imgUrl;
        data.editform.imgData = data1.shop.img;
        data.editform.name = data1.shop.name;
        data.editform.phone = data1.shop.phone;
        data.editform.weixin = data1.shop.weixin;
        data.editform.ne = data1.shop.ne;
        // 初始化echarts
        initEchart();
      }, error => {
        if (error.code == 101) {
          ElMessage({
            type: 'error',
            message: error.msg
          });
          router.push('/update');
        }
        if (error.code == 1023) {
          router.push('/login');
        }
      });
    };

    // 判断用户是否是联盟公司
    const isCompany = () => {
      return data.userInfo.shop.type != 1;
    };
    // 赎回表单验证
    const redeemRules = {
      num: [{
        required: true,
        message: '请输入赎回金额',
        trigger: 'blur'
      }]
    };
    // 提现表单验证
    const withdrawCashRules = {
      name: [{
        required: true,
        message: '请输入银行名称',
        trigger: 'blur'
      }],
      kname: [{
        required: true,
        message: '请输入开户行名称',
        trigger: 'blur'
      }],
      id: [{
        required: true,
        message: '请输入银行卡卡号',
        trigger: 'blur'
      }],
      username: [{
        required: true,
        message: '请输入真实姓名',
        trigger: 'blur'
      }],
      num: [{
        required: true,
        message: '请输入提现金额',
        trigger: 'blur'
      }]
    };
    // 编辑表单验证
    const editRules = {
      name: [{
        required: true,
        message: '请输入商铺名称',
        trigger: 'blur'
      }],
      imgData: [{
        required: true,
        message: '请上传商铺logo',
        trigger: 'blur'
      }],
      phone: [{
        required: true,
        message: '请输入手机号',
        trigger: 'blur'
      }],
      weixin: [{
        required: true,
        message: '请输入微信号',
        trigger: 'blur'
      }],
      ne: [{
        required: true,
        message: '请输入别名',
        trigger: 'blur'
      }, {
        min: 2,
        max: 2,
        message: '请输入两个字',
        trigger: 'blur'
      }]
    };
    // 个人绑定银行账号验证
    const bindPeopleRules = {
      card_name: [{
        required: true,
        message: '请输入卡主名字',
        trigger: 'blur'
      }],
      card_id: [{
        required: true,
        message: '请输入银行卡号',
        trigger: 'blur'
      }],
      cert_id: [{
        required: true,
        message: '请输入银行卡绑定的身份证号码',
        trigger: 'blur'
      }],
      phone: [{
        required: true,
        message: '请输入银行预留的电话号码',
        trigger: 'blur'
      }]
    };
    // 个人绑定银行账号验证
    const bindCompRules = {
      name: [{
        required: true,
        message: '请输入企业名称',
        trigger: 'blur'
      }],
      prov_code: [{
        required: true,
        message: '请选择省份编码',
        trigger: 'blur'
      }],
      attach_file: [{
        required: true,
        message: '请上传附件',
        trigger: 'blur'
      }],
      area_code: [{
        required: true,
        message: '请选择地区编码',
        trigger: 'blur'
      }],
      social_credit_code: [{
        required: true,
        message: '请输入统一社会信用编码',
        trigger: 'blur'
      }],
      social_credit_code_expires: [{
        required: true,
        message: '请选择统一社会信用证有效期',
        trigger: 'blur'
      }],
      business_scope: [{
        required: true,
        message: '请输入经营范围',
        trigger: 'blur'
      }],
      legal_person: [{
        required: true,
        message: '请输入法人姓名',
        trigger: 'blur'
      }],
      legal_cert_id: [{
        required: true,
        message: '请输入身份证号码',
        trigger: 'blur'
      }],
      legal_cert_id_expires: [{
        required: true,
        message: '请选择身份证有效期',
        trigger: 'blur'
      }],
      legal_mp: [{
        required: true,
        message: '请输入法人手机号',
        trigger: 'blur'
      }],
      address: [{
        required: true,
        message: '请输入企业地址',
        trigger: 'blur'
      }],
      bank_code: [{
        required: true,
        message: '请选择银行代码',
        trigger: 'blur'
      }],
      bank_acct_type: [{
        required: true,
        message: '请选择账号类型',
        trigger: 'blur'
      }],
      card_no: [{
        required: true,
        message: '请输入银行卡号',
        trigger: 'blur'
      }],
      card_name: [{
        required: true,
        message: '请输入银行卡对应的户名',
        trigger: 'blur'
      }]
    };
    // 对金额格式化
    const CNYformat = number => {
      const option = {
        style: 'currency',
        currency: 'CNY'
      };
      if (typeof number !== Number) {
        number = parseFloat(number);
      }
      return number.toLocaleString('zh-CN', option);
    };
    // 查询银行账号信息
    const QueryAccountInformation = () => {
      ajax('Merchant/selectblank', res => {}, err => {}, {});
    };
    // 初始化echart图表
    const initEchart = () => {
      const arr = [];
      if (data.binList) {
        data.binList.map(item => {
          const obj = {
            name: item.name,
            value: item.sum
          };
          arr.push(obj);
        });
      }
      // 注册echart实例
      var myChart = echarts.init(echart.value);
      // console.log(myChart);
      // echart配置
      const options = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [{
          name: 'Access From',
          type: 'pie',
          radius: '50%',
          data: arr,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          label: {
            formatter(ret) {
              return ret.percent + '%';
            }
          }
        }]
      };
      myChart.setOption(options);
    };
    // 获取银行信息编码
    const getyhbm = () => {
      ajax('Merchant/getcode', res => {
        data.yhbm = res.data;
      }, () => {});
    };
    // 获取银行代码
    const getyhdm = () => {
      ajax('Merchant/getbankcode', res => {
        data.yhdm = res.data;
      }, () => {});
    };
    // 重新上传头像
    const uploadOneImg = () => {
      const input = document.createElement('input');
      input.type = 'file';
      input.addEventListener('input', e => {
        ajax('User_fun/up_img', res => {
          if (res.code === 0) {
            data.editform.imgData = res.data;
            data.editform.imgUrl = res.url;
          }
        }, () => {}, {
          file: e.target.files[0]
        });
      });
      input.click();
    };
    const expansionMenu = value => {
      data.cities.map(item => {
        state.closeMenu(item.path);
      });
      // state.openMenu(value)
      router.push(value);
      // console.log(value);
    };
    // ------------编辑
    const edit = () => {
      getData();
      editVisible.value = true;
    };
    // 确认按钮
    const editTrue = async formEl => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          ajax('Merchant/updatemsg', res => {
            editVisible.value = false;
            ElMessage({
              message: res.msg,
              type: 'success'
            });
          }, error => {
            ElMessage({
              message: error.msg,
              type: 'error'
            });
          }, {
            name: data.editform.name,
            img: data.editform.imgData,
            phone: data.editform.phone,
            weixin: data.editform.weixin,
            ne: data.editform.ne
          });
        } else {}
      });
    };
    // ------------赎回
    const redeem = () => {
      if (!isCompany()) {
        data.redeemform.num = '';
        redeemVisible.value = true;
      } else {
        ElMessage({
          message: '联盟公司不可进行赎回操作',
          type: 'error'
        });
      }
    };
    // 确认按钮
    const redeemTrue = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          ajax('Merchant/ransom', res => {
            redeemVisible.value = false;
            ElMessage({
              message: res.msg,
              type: 'success'
            });
          }, error => {
            ElMessage({
              message: error.msg,
              type: 'error'
            });
          }, {
            num: data.redeemform.num
          });
        } else {
          return false;
        }
      });
    };
    // ------------提现
    const withdrawCash = () => {
      data.withdrawCashform = {
        name: '',
        // 银行名称
        kname: '',
        // 开户行名称
        id: '',
        // 卡号
        username: '',
        // 真实姓名
        num: '' // 金额数量
      }; //提现表单数据
      if (!isCompany()) {
        withdrawCashVisible.value = true;
      } else {
        ElMessage({
          message: '联盟公司不可进行赎回操作',
          type: 'error'
        });
      }
    };
    // 确认按钮
    const withdrawCashTrue = async formEl => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          const {
            name,
            kname,
            id,
            username,
            num
          } = data.withdrawCashform;
          ajax('Merchant/withdraw', res => {
            if (res.code == 0) {
              ElMessage({
                message: res.msg,
                type: 'success'
              });
              withdrawCashVisible.value = false;
            }
          }, error => {
            ElMessage({
              message: error.msg,
              type: 'error'
            });
          }, {
            name,
            kname,
            id,
            username,
            num
          });
        } else {}
      });
    };
    // ------------注销
    const logout = () => {
      if (!isCompany()) {
        ElMessageBox.confirm('您确定要注销吗', '注销', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajax('Merchant/logout', res => {
            ElMessage({
              message: res.msg,
              type: 'success'
            });
            localStorage.removeItem('token_data');
            localStorage.removeItem('token');
            router.replace({
              name: 'login'
            });
          }, error => {
            ElMessage({
              message: error.msg,
              type: 'error'
            });
          });
          // ElMessage({
          //   type: 'success',
          //   message: 'Delete completed',
          // })
        }).catch(() => {});
      } else {
        ElMessage({
          message: '联盟公司不可注销',
          type: 'error'
        });
      }
    };
    // ------------绑定个人银行账号
    const bindPeople = () => {
      bingPeopleVisible.value = true;
    };
    // 确认按钮
    const bingPeopleTrue = async formEl => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          ajax('Merchant/bindblank', res => {
            if (res.code == 0) {
              ElMessage({
                message: res.msg,
                type: 'success'
              });
              bingPeopleVisible.value = false;
            }
          }, error => {
            ElMessage({
              message: error.msg,
              type: 'error'
            });
          }, {
            ...data.bindPeopleform
          });
        } else {}
      });
    };
    // ------------绑定企业银行账号
    const bindComp = () => {
      bindCompVisible.value = true;
    };
    // 确认按钮
    const bindCompTrue = async formEl => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          ajax('Merchant/withdraws', res => {
            if (res.code == 0) {
              ElMessage({
                message: res.msg,
                type: 'success'
              });
              bindCompVisible.value = false;
            }
          }, error => {
            ElMessage({
              message: error.msg,
              type: 'error'
            });
          }, {
            ...data.bindCompform
          });
        } else {}
      });
    };
    // 上传触发事件
    const uploadAllComp = item => {
      data.fileList = [];
      data.bindCompform.attach_file = '';
      const obj = {
        name: item.file.name,
        percentage: 0,
        raw: item.file,
        size: item.file.size,
        status: 'ready',
        uid: item.file.uid
      };
      data.fileList.push(obj);
      ajax('Merchant/upfile', res => {
        data.bindCompform.attach_file = res.data;
      }, error => {}, {
        attach_file: item.file
      });
    };
    // 移除事件
    const handleRemove = () => {
      data.bindCompform.attach_file = '';
      data.fileList = [];
    };
    // ------------查看或修改个人信息
    const lookInfo = () => {
      changePeopleInfoVisible.value = true;
    };
    // 获取个人用户信息
    const getPeopleInfo = () => {
      ajax('Merchant/selectblank', res => {
        data.lookPeopleInfo = res.data;
      }, () => {}, {});
    };
    // 判断用户状态
    onMounted(() => {
      getData();
      getyhbm();
      getyhdm();
      getPeopleInfo();
      setTimeout(() => {
        if (data.userInfo.shop?.zt != 1) {
          router.replace('/update');
        }
      }, 500);
      const routes = router.getRoutes();
      // 根据路由动态生成可操作按钮
      data.cities = routes.filter(item => {
        if (item.path.split('/').length === 2 && item.path !== '/' && item.path !== '/' && item.path !== '/update' && item.path !== '/login' && item.path !== '/xy') {
          return item;
        }
      });
      QueryAccountInformation();
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_upload = _resolveComponent("el-upload");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createTextVNode(" 总销售额 "), data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(CNYformat(data.userInfo.data.a5)), 1)) : _createCommentVNode("", true), data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_5, "商品未通过:" + _toDisplayString(data.userInfo.data.a9), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_createTextVNode(" 订单总数 "), data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(data.userInfo.data.a1), 1)) : _createCommentVNode("", true), data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_8, "订单完成:" + _toDisplayString(data.userInfo.data.a2), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_createTextVNode(" 商品总数 "), data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(data.userInfo.data.a6), 1)) : _createCommentVNode("", true), data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_11, "商品已上架:" + _toDisplayString(data.userInfo.data.a7), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createTextVNode(" 有效金额 "), data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(CNYformat(data.userInfo.data.a4)), 1)) : _createCommentVNode("", true), data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_14, "商品待审核:" + _toDisplayString(data.userInfo.data.a8), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("header", null, [_createElementVNode("div", null, [_createTextVNode(" 店铺信息     "), data.userInfo.shop?.ggkey == '' ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        style: {
          "cursor": "pointer"
        },
        onClick: bindPeople
      }, " 个人绑定    ")) : _createCommentVNode("", true), data.userInfo.shop?.ggkey == '' ? (_openBlock(), _createElementBlock("span", {
        key: 1,
        style: {
          "cursor": "pointer"
        },
        onClick: bindComp
      }, " 企业绑定    ")) : _createCommentVNode("", true), _createElementVNode("span", {
        style: {
          "cursor": "pointer"
        },
        onClick: lookInfo
      }, "查看")]), data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(data.userInfo.shop.type == 1 ? '云店' : '联盟公司'), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [data.userInfo ? (_openBlock(), _createBlock(_component_el_image, {
        key: 0,
        style: {
          "width": "80px",
          "height": "80px",
          "border-radius": "50%"
        },
        src: data.userInfo.shop.imgUrl
      }, null, 8, ["src"])) : _createCommentVNode("", true)]), data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_hoisted_23, _createTextVNode(" " + _toDisplayString(data.userInfo.shop.name), 1)])) : _createCommentVNode("", true), data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_hoisted_25, _createTextVNode(" " + _toDisplayString(data.userInfo.shop.phone), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_26, [data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_hoisted_28, _createTextVNode(" " + _toDisplayString(data.userInfo.shop.money), 1)])) : _createCommentVNode("", true), data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_hoisted_30, _createTextVNode(" " + _toDisplayString(CNYformat(data.userInfo.shop.total)), 1)])) : _createCommentVNode("", true), data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_hoisted_32, _createTextVNode(" " + _toDisplayString(CNYformat(data.userInfo.shop.rl)), 1)])) : _createCommentVNode("", true), data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_hoisted_34, _createTextVNode(" " + _toDisplayString(CNYformat(data.userInfo.shop.yjf)), 1)])) : _createCommentVNode("", true)])]), _createElementVNode("div", {
        class: "right"
      }, [_createElementVNode("div", {
        class: "user_operate"
      }, [_createElementVNode("span", {
        onClick: edit
      }, "编辑"), _createElementVNode("span", {
        onClick: redeem
      }, "赎回"), _createElementVNode("span", {
        onClick: withdrawCash
      }, "提现"), _createElementVNode("span", {
        onClick: logout
      }, "注销")])])])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", {
        ref_key: "echart",
        ref: echart,
        style: {
          "width": "100%",
          "height": "100%"
        },
        id: "main"
      }, null, 512)])]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_hoisted_38, _createElementVNode("div", _hoisted_39, [_createVNode(_component_el_radio_group, {
        onChange: expansionMenu,
        modelValue: radio.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => radio.value = $event),
        size: "large"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.cities, item => {
          return _openBlock(), _createBlock(_component_el_radio_button, {
            key: item.path,
            label: item.path
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.meta.title), 1)]),
            _: 2
          }, 1032, ["label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])])])]), _createVNode(_component_el_dialog, {
        modelValue: editVisible.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => editVisible.value = $event),
        title: "编辑商铺信息"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_41, [_createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = $event => editTrue(editRuleFormRef.value))
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[6] || (_cache[6] = $event => editVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_hoisted_40, _createVNode(_component_el_form, {
          ref_key: "editRuleFormRef",
          ref: editRuleFormRef,
          rules: editRules,
          model: data.editform
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "商铺名称:",
            "label-width": 90,
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.editform.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.editform.name = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "别名:",
            "label-width": 90,
            prop: "ne"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.editform.ne,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.editform.ne = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "商铺logo:",
            "label-width": 90,
            prop: "imgData"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_image, {
              lazy: "",
              style: {
                "width": "80px",
                "height": "80px",
                "display": "block",
                "border-radius": "50%"
              },
              src: data.editform.imgUrl,
              fit: _ctx.fit
            }, null, 8, ["src", "fit"]), _createVNode(_component_el_button, {
              onClick: uploadOneImg,
              style: {
                "margin-top": "10px",
                "display": "block"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(" 重新上传 ")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "手机号:",
            "label-width": 90,
            prop: "phone"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.editform.phone,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.editform.phone = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "微信号:",
            "label-width": 90,
            prop: "weixin"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.editform.weixin,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => data.editform.weixin = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: redeemVisible.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => redeemVisible.value = $event),
        title: "赎回"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_42, [_createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = $event => redeemTrue(redeemRuleFormRef.value))
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[10] || (_cache[10] = $event => redeemVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "redeemRuleFormRef",
          ref: redeemRuleFormRef,
          rules: redeemRules,
          model: data.redeemform
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "赎回金额:",
            "label-width": 90,
            prop: "num"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.redeemform.num,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => data.redeemform.num = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: withdrawCashVisible.value,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => withdrawCashVisible.value = $event),
        title: "提交提现审核"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_43, [_createVNode(_component_el_button, {
          onClick: _cache[17] || (_cache[17] = $event => withdrawCashTrue(withdrawCashRuleFormRef.value))
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[18] || (_cache[18] = $event => withdrawCashVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "withdrawCashRuleFormRef",
          ref: withdrawCashRuleFormRef,
          rules: withdrawCashRules,
          model: data.withdrawCashform
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "银行名称:",
            "label-width": 96,
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.withdrawCashform.name,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => data.withdrawCashform.name = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "开户行名称:",
            "label-width": 96,
            prop: "kname"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.withdrawCashform.kname,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => data.withdrawCashform.kname = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "卡号:",
            "label-width": 96,
            prop: "id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.withdrawCashform.id,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => data.withdrawCashform.id = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "真实姓名:",
            "label-width": 96,
            prop: "username"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.withdrawCashform.username,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => data.withdrawCashform.username = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "金额数量:",
            "label-width": 96,
            prop: "num"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.withdrawCashform.num,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => data.withdrawCashform.num = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: bingPeopleVisible.value,
        "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => bingPeopleVisible.value = $event),
        title: "绑定个人银行账号"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_44, [_createVNode(_component_el_button, {
          onClick: _cache[24] || (_cache[24] = $event => bingPeopleTrue(bindPeopleRuleFormRef.value))
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[25] || (_cache[25] = $event => bingPeopleVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "bindPeopleRuleFormRef",
          ref: bindPeopleRuleFormRef,
          rules: bindPeopleRules,
          model: data.bindPeopleform
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "卡主名字:",
            "label-width": 120,
            prop: "card_name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.bindPeopleform.card_name,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => data.bindPeopleform.card_name = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "银行卡号:",
            "label-width": 120,
            prop: "card_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.bindPeopleform.card_id,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => data.bindPeopleform.card_id = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "身份证号码:",
            "label-width": 120,
            prop: "cert_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.bindPeopleform.cert_id,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => data.bindPeopleform.cert_id = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "银行预留电话:",
            "label-width": 120,
            prop: "phone"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.bindPeopleform.phone,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => data.bindPeopleform.phone = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: bindCompVisible.value,
        "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => bindCompVisible.value = $event),
        title: "绑定企业银行账号"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_46, [_createVNode(_component_el_button, {
          onClick: _cache[43] || (_cache[43] = $event => bindCompTrue(bindCompRuleFormRef.value))
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[44] || (_cache[44] = $event => bindCompVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "bindCompRuleFormRef",
          ref: bindCompRuleFormRef,
          rules: bindCompRules,
          model: data.bindCompform
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "企业名称:",
            "label-width": 160,
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "输入企业名称",
              modelValue: data.bindCompform.name,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => data.bindCompform.name = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "省份编码:",
            "label-width": 160,
            prop: "prov_code"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_cascader, {
              props: {
                label: 'title',
                children: 'cities',
                emitPath: false
              },
              modelValue: data.bindCompform.prov_code,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => data.bindCompform.prov_code = $event),
              options: data.yhbm,
              "show-all-levels": false
            }, null, 8, ["modelValue", "options"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "地区编码:",
            "label-width": 160,
            prop: "area_code"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_cascader, {
              props: {
                label: 'title',
                children: 'cities',
                emitPath: false
              },
              modelValue: data.bindCompform.area_code,
              "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => data.bindCompform.area_code = $event),
              options: data.yhbm,
              "show-all-levels": false
            }, null, 8, ["modelValue", "options"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "统一社会信用码:",
            "label-width": 160,
            prop: "social_credit_code"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "输入企业名称统一社会信用码",
              modelValue: data.bindCompform.social_credit_code,
              "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => data.bindCompform.social_credit_code = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "统一社会信用证有效期:",
            "label-width": 160,
            prop: "social_credit_code_expires"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: data.bindCompform.social_credit_code_expires,
              "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => data.bindCompform.social_credit_code_expires = $event),
              type: "date",
              placeholder: "选择统一社会信用证有效期",
              size: _ctx.size,
              "value-format": "YYYYMMDD"
            }, null, 8, ["modelValue", "size"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "经营范围:",
            "label-width": 160,
            prop: "business_scope"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              modelValue: data.bindCompform.business_scope,
              "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => data.bindCompform.business_scope = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "法人姓名:",
            "label-width": 160,
            prop: "legal_person"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "请输入法人姓名",
              modelValue: data.bindCompform.legal_person,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => data.bindCompform.legal_person = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "法人身份证号码:",
            "label-width": 160,
            prop: "legal_cert_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "请输入法人身份证号码",
              modelValue: data.bindCompform.legal_cert_id,
              "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => data.bindCompform.legal_cert_id = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "法人身份证有效期:",
            "label-width": 160,
            prop: "legal_cert_id_expires"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: data.bindCompform.legal_cert_id_expires,
              "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => data.bindCompform.legal_cert_id_expires = $event),
              type: "date",
              "value-format": "YYYYMMDD",
              placeholder: "选择法人身份证有效期",
              size: _ctx.size
            }, null, 8, ["modelValue", "size"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "法人手机号:",
            "label-width": 160,
            prop: "legal_mp"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.bindCompform.legal_mp,
              "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => data.bindCompform.legal_mp = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "企业地址:",
            "label-width": 160
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              modelValue: data.bindCompform.address,
              "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => data.bindCompform.address = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "银行代码:",
            "label-width": 160,
            prop: "bank_code"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: data.bindCompform.bank_code,
              "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => data.bindCompform.bank_code = $event),
              class: "m-2",
              placeholder: "请选择银行代码",
              size: "large"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.yhdm, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "银行账号类型:",
            "label-width": 160,
            prop: "bank_acct_type"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: data.bindCompform.bank_acct_type,
              "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => data.bindCompform.bank_acct_type = $event),
              class: "ml-2",
              "inline-prompt": "",
              style: {
                "--el-switch-on-color": "#13ce66",
                "--el-switch-off-color": "#ff4949"
              },
              "active-text": "对公",
              "inactive-text": "对私",
              "active-value": "1",
              "inactive-value": "2"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "银行卡号:",
            "label-width": 160,
            prop: "card_no"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.bindCompform.card_no,
              "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => data.bindCompform.card_no = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "银行卡对应的户名:",
            "label-width": 160,
            prop: "card_name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.bindCompform.card_name,
              "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => data.bindCompform.card_name = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "上传附件:",
            "label-width": 160,
            prop: "attach_file"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              "file-list": data.fileList,
              "onUpdate:fileList": _cache[42] || (_cache[42] = $event => data.fileList = $event),
              class: "upload-demo",
              ref_key: "upload",
              ref: upload,
              multiple: "",
              "http-request": uploadAllComp,
              "on-remove": handleRemove
            }, {
              tip: _withCtx(() => [_hoisted_45]),
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode("上传")]),
                _: 1
              })]),
              _: 1
            }, 8, ["file-list"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        class: "look-people",
        modelValue: changePeopleInfoVisible.value,
        "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => changePeopleInfoVisible.value = $event),
        title: "查看个人绑定信息"
      }, {
        default: _withCtx(() => [_hoisted_47, _createElementVNode("div", null, "邮箱:" + _toDisplayString(data.lookPeopleInfo.email), 1), _createElementVNode("div", null, "地区:" + _toDisplayString(data.lookPeopleInfo.location), 1), _createElementVNode("div", null, "别名:" + _toDisplayString(data.lookPeopleInfo.nickname), 1), _createElementVNode("div", null, "手机号:" + _toDisplayString(data.lookPeopleInfo.tel_no), 1), _hoisted_48, _createElementVNode("div", null, "法人姓名:" + _toDisplayString(data.lookPeopleInfo.settle_accounts[0]?.account_info.card_name), 1), _createElementVNode("div", null, "法人手机号:" + _toDisplayString(data.lookPeopleInfo.settle_accounts[0]?.account_info.tel_no), 1), _createElementVNode("div", null, "法人身份证:" + _toDisplayString(data.lookPeopleInfo.settle_accounts[0]?.account_info.cert_id), 1), _createElementVNode("div", null, "法人银行卡:" + _toDisplayString(data.lookPeopleInfo.settle_accounts[0]?.account_info.card_id), 1), _createElementVNode("div", null, " 银行账户类型:" + _toDisplayString(data.lookPeopleInfo.settle_accounts[0]?.account_info.bank_acct_type == 1 ? '对公' : '对私'), 1), _createElementVNode("div", null, "银行代码:" + _toDisplayString(data.lookPeopleInfo.settle_accounts[0]?.account_info.bank_code), 1), _createElementVNode("div", null, "省份编码:" + _toDisplayString(data.lookPeopleInfo.settle_accounts[0]?.account_info.prov_code), 1), _createElementVNode("div", null, "地区编码:" + _toDisplayString(data.lookPeopleInfo.settle_accounts[0]?.account_info.area_code), 1)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};